<template>
  <div class="promotion-lessons">
    <LearnSupportClassCard
      class="promotion-lessons__card"
      v-for="lesson in lessons"
      :key="lesson.id"
      :item="lesson"
      :rounded-card="true"
      :button-hidden="true"
      player-type="new"
    />
  </div>
</template>


<script>

import LearnSupportClassCard from '@/components/creator-school/learnAndSupport/LearnSupportClassCard.vue';

export default {
  name: 'PromotionLessons',
  components: { LearnSupportClassCard },
  props: {
    lessons: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
@import "~@/assets/scss/mixins";

.promotion-lessons {
  display: flex;
  gap: 32px;

  @include media-sm-only() {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  @include media-lg() {
    flex-direction: column;
    gap: 40px;
  }

  &__card {
    @include media-sm-only() {
      max-width: 327px;
    }
  }
}

</style>
